import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { createLogger } from '../../utils/logger';

const logger = createLogger('EmployeeOrAdminRoute');

function EmployeeOrAdminRoute() {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return <div>Loading authentication state...</div>; // Or a spinner
  }

  if (!currentUser) {
    // Not logged in, redirect to login page
    // You might want to pass the intended destination via location state
    return <Navigate to="/login" replace />;
  }

  if (userRole !== 'Admin' && userRole !== 'Employee') {
    // Logged in but not an Admin or Employee, redirect to home or an unauthorized page
    logger.warn('Unauthorized access attempt', { userRole });
    // For now, redirecting to home page. You could create a dedicated "Unauthorized" page.
    return <Navigate to="/" replace />;
  }

  // User is authenticated and is an Admin or Employee
  return <Outlet />;
}

export default EmployeeOrAdminRoute;
